import { FC, useRef } from 'react'
import { Modal } from 'react-bootstrap'
import QRCode from 'react-qr-code'

interface PrintQRCodeModalProps {
  show: boolean
  onHide: () => void
  linkPainel: string | null
  title?: string
}

export const PrintQRCodeModal: FC<PrintQRCodeModalProps> = ({
  show,
  onHide,
  linkPainel,
  title = 'Imprimir QR Code de Fila',
}) => {
  const qrRef = useRef<HTMLDivElement>(null)

  const handlePrint = () => {
    if (qrRef.current) {
      const printWindow = window.open('', '', 'height=600,width=600')
      if (printWindow) {
        const qrContent = qrRef.current.innerHTML
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>${title}</title>
              <style>
                body {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  min-height: 100vh;
                  margin: 0;
                  padding: 20px;
                  font-family: Arial, sans-serif;
                }
                .print-container {
                  text-align: center;
                }
                .qr-wrapper {
                  display: flex;
                  justify-content: center;
                  margin-bottom: 20px;
                }
                h2 {
                  font-size: 24px;
                  margin-bottom: 10px;
                }
                p {
                  font-size: 14px;
                  color: #666;
                  margin: 5px 0;
                }
                @media print {
                  body {
                    margin: 0;
                    padding: 0;
                  }
                }
              </style>
            </head>
            <body>
              <div class="print-container">
                <h2>QR Code da Fila</h2>
                <p>Escaneie para acessar a fila de espera</p>
                <div class="qr-wrapper">
                  ${qrContent}
                </div>
                <p style="margin-top: 20px; font-size: 12px;">
                  ${linkPainel || ''}
                </p>
              </div>
            </body>
          </html>
        `)
        printWindow.document.close()
        
        // Aguardar o conteúdo ser renderizado antes de imprimir
        setTimeout(() => {
          printWindow.focus()
          printWindow.print()
          printWindow.close()
        }, 250)
      }
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered size='sm'>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className='d-flex flex-column align-items-center gap-3 py-4'>
        {linkPainel ? (
          <>
            <div
              ref={qrRef}
              className='bg-white p-3'
              style={{
                border: '2px solid #dee2e6',
                borderRadius: '8px',
              }}
            >
              <QRCode value={linkPainel} size={250} level='H' />
            </div>
            <div className='text-center w-100'>
              <p className='mb-1 small text-muted'>Link da Fila:</p>
              <p className='mb-0 small' style={{ wordBreak: 'break-all', color: '#495057' }}>
                {linkPainel}
              </p>
            </div>
          </>
        ) : (
          <div className='alert alert-warning w-100 mb-0' role='alert'>
            <i className='fas fa-exclamation-triangle me-2'></i>
            Nenhum link de fila configurado. Por favor, configure o link antes de gerar o QR Code.
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        {linkPainel && (
          <button
            className='btn btn-primary'
            onClick={handlePrint}
            style={{ height: '40px', fontSize: '15px', fontWeight: '500' }}
          >
            <i className='fas fa-print me-2'></i>
            Imprimir
          </button>
        )}
        <button
          className='btn btn-secondary'
          onClick={onHide}
          style={{ height: '40px', fontSize: '15px', fontWeight: '500' }}
        >
          Fechar
        </button>
      </Modal.Footer>
    </Modal>
  )
}
